export default "__VITE_ASSET__CyQIQKn1__"